export interface Contact {
  id?: number;
  nom: string;
  prenom: string;
  telephone: string;
  email: string;
  archived?: boolean;
}

export interface Client {
  id?: number;
  numeroClient: string;
  siret: string;
  denomination: string;
  adresseFacturation: string;
  ville: string;
  codePostal: string;
  photo?: any;
  archived?: boolean;
  contacts?: Contact[];
}

export interface PageResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
}

export enum MetaStatus {
  DRAFT = 'DRAFT',
  VALIDE = 'VALIDE',
  TERMINE = 'TERMINE'
}

export enum StatusType {
  PROJECT = 'PROJECT',
  FAT = 'FAT'
}

export interface CustomStatus {
  id?: number;
  name: string;
  metaStatus: MetaStatus;
  type?: StatusType;
  color?: string;
  archived?: boolean;
}

export interface Project {
  id?: number;
  name: string;
  deliveryAddress: string;
  city: string;
  zipCode: string;
  availabilityDate: string;
  deliveryDate: string;
  statusId?: number;
  statusName?: string;
  statusColor?: string;
  metaStatus?: MetaStatus;
  archived?: boolean;
  affaireId?: number | null;
  sousTraitantIds?: number[] | null;
  voltage?: string;
  puissanceTransfo1?: string;
  puissanceTransfo2?: string;
  typeTransfo1?: string;
  typeTransfo2?: string;
  comptage?: string;
  createdAt?: string;
  workflowId?: number | null;
  workflowName?: string;
  currentStepOrder?: number | null;
  workflowAssignedAt?: string;
  workflowAssignedByUsername?: string;
}

export interface Team {
  id?: number;
  name: string;
  description?: string;
  membersCount?: number;
  archived?: boolean;
}

export interface TeamMember {
  id: number;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
}

export enum WorkflowStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum WorkflowType {
  PROJECT = 'PROJECT',
  FAT = 'FAT'
}

export enum WorkflowAction {
  VALIDATE = 'VALIDATE',
  REJECT = 'REJECT'
}

export interface WorkflowStepTeamAssignment {
  id?: number;
  teamId: number;
  teamName?: string;
  permissions: WorkflowAction[];
}

export interface WorkflowStep {
  id?: number;
  name: string;
  description?: string;
  stepOrder: number;
  initialStatusId: number;
  initialStatusName?: string;
  finalStatusId: number;
  finalStatusName?: string;
  teamAssignments: WorkflowStepTeamAssignment[];
}

export interface Workflow {
  id?: number;
  name: string;
  description?: string;
  status: WorkflowStatus;
  type?: WorkflowType;
  steps: WorkflowStep[];
}

export interface StepPermissions {
  noWorkflow: boolean;
  canValidate: boolean;
  canReject: boolean;
  currentStepOrder?: number;
  teamAssignments: WorkflowStepTeamAssignment[];
}

export interface ProjectDocReferential {
  id?: number;
  name: string;
  maxDocs: number;
  mandatory?: boolean;
  commentMandatory?: boolean;
  docReferenceMandatory?: boolean;
  commentPlaceholder?: string;
  archived?: boolean;
  versionId?: number;
}

export interface DocTypeVersion {
  id?: number;
  version: string;
  validated: boolean;
  createdAt?: string;
  docTypes: ProjectDocReferential[];
}

export interface ProjectDoc {
  id?: number;
  projectId: number;
  referentialId: number;
  referentialName: string;
  fileName: string;
  contentType: string;
  size: number;
  comment?: string;
  docReference?: string;
}

export interface SousTraitant {
  id?: number;
  codeComptable: string;
  denomination: string;
  siret: string;
  qualification: string;
  adresse: string;
  ville: string;
  codePostal: string;
  archived?: boolean;
}

export interface FatTemplateField {
  orderId: number;
  name: string;
  result: string;
  comment: string;
  possibleResults?: string; // Format: "Conforme,Non Conforme,Non Applicable"
  commentMandatory?: boolean;
  commentPlaceholder?: string;
  type?: string;
  minPhotosNbr?: number;
  comptage?: string;
  transformerType?: string;
  includeInReportAnnexes?: boolean;
}

export interface FatTemplateSubcategory {
  name: string;
  fields: FatTemplateField[];
}

export interface FatTemplateCategory {
  name: string;
  subcategories: FatTemplateSubcategory[];
}

export enum FatTemplateStatus {
  DRAFT = 'DRAFT',
  VALIDATED = 'VALIDATED'
}

export interface FatTemplate {
  version: string;
  validated?: boolean;
  status?: FatTemplateStatus;
  categories: FatTemplateCategory[];
}

export interface FatTemplateImportStatus {
  jobId: number;
  status: string;
  templateVersion?: string;
  errorMessage?: string;
}

export interface AffaireFile {
  id: number;
  fileName: string;
  fileType: string;
}

export interface ProjectShort {
  id: number;
  name: string;
  statusName: string;
  metaStatus: MetaStatus;
  statusColor?: string;
}

export interface Affaire {
  id?: number;
  numeroAffaire: string;
  createdAt?: string;
  dateCreation?: string;
  client: Client;
  archived?: boolean;
  files?: AffaireFile[];
  projects?: ProjectShort[];
}

export interface ComptageRule {
  id?: number;
  name: string;
  minTension: number;
  minPuissance: number;
  maxTension: number;
  maxPuissance: number;
  voltageOptions: string;
  puissanceOptions: string;
  active: boolean;
  archived?: boolean;
}

export interface Role {
  id?: number;
  name: string;
}
